export const INTERNAL_CUSTOMER_ENDPOINT = '/customers';
export const INTERNAL_ORDER_HISTORY_ENDPOINT = '/orders-history';
export const INTERNAL_CREDIT_HISTORY_ENDPOINT = '/credit-history';
export const INTERNAL_ACCOUNT_HISTORY_ENDPOINT = '/account-history';
export const INTERNAL_POINTS_HISTORY_ENDPOINT = '/points-history';
export const INTERNAL_PACKAGES_ENDPOINT = '/packages';
export const INTERNAL_STORES_ENDPOINT = '/stores';
export const INTERNAL_LOGIN_ENDPOINT = '/login';
export const INTERNAL_CONFIGS_ENDPOINT = '/configs';
export const INTERNAL_RUNTIME_CONFIG_ENDPOINT = '/runtime-config';
export const INTERNAL_TIER_RANK_ENDPOINT = '/tier-rank';

export const INTERNAL_REWARDS_ENDPOINT = '/rewards';
export const INTERNAL_MY_REWARDS_ENDPOINT = '/my-rewards';
export const INTERNAL_MEMBERS_ENDPOINT = '/members';
export const INTERNAL_REFERRAL_RULE_ENDPOINT = '/referral-rule';
export const INTERNAL_BROADCAST_VOUCHERS_ENDPOINT = `${INTERNAL_REWARDS_ENDPOINT}/broadcast-vouchers`;

